import {cn} from '@bem-react/classname';
import {PopupPlacement} from '@gravity-ui/uikit';

const {basePath} = window.YC;

export const popupPlacement: PopupPlacement = [
    'bottom-end',
    'bottom-start',
    'right-end',
    'right-start',
    'top-end',
    'top-start',
];

export const basePathWithoutLastSlash = basePath.slice(0, basePath.length - 1);

export const cnMenuContent = cn('yc-user-dropdown');
